// bao migrate skip
import TabPage from "./../factories/tab-page";
import "./../services/bao-menu";
import "./../services/bao-router";
import "./../bindings/filtering";
import "./../bindings/foreach-selection";
import "./../bindings/sorting";
import Bao from "./../services/bao-service";
import * as ko from "knockout";
import * as moment from "moment";
import BaoDialog from "./../factories/bao-dialog";
import BaoMenu from "./../services/bao-menu";
import baoRouter from "./../services/bao-router";
import baoShouter from "./../services/bao-shouter";
import MessageBus, { IMessageBusEventHandler } from "./../services/message-bus";
import SubscriptionViewModel from "../factories/subscription-view-model";

class SummaryReportV2 extends SubscriptionViewModel {
    SelectedSummaryFilter = ko.observable<{
        FilterInterval: KnockoutObservable<number>;
        FilterIntervalStartDay: KnockoutObservable<number>;
        FilterIntervalStartTime: KnockoutObservable<string>;
        FilterIntervalEndDay: KnockoutObservable<number>;
        FilterIntervalEndTime: KnockoutObservable<string>;
        FilterIntervalKey: KnockoutObservable<string>;
        SummaryReportId: KnockoutObservable<string>;
        Name: KnockoutObservable<string>;
        IsIndividually: KnockoutObservable<boolean>;
    }>();
    SelectedSummaryReportId = ko.observable("");
    IsIndividually = ko.pureComputed(() => { return this.SelectedSummaryFilter()?.IsIndividually() ?? false; });
    Color: string = "text-primary";
    Icon: string = "fal fa-layer-group";
    Sort: number = 120;
    availableSummaryFilters: KnockoutObservable<any> = ko.observable([]);
    Selection = ko.observableArray();
    IsFavorite: KnockoutObservable<boolean> = ko.observable(false);
    IsFilterSet: KnockoutObservable<boolean> = ko.observable(false);
    FilterPeriodFrom = ko.observable("");
    FilterPeriodTo = ko.observable("");
    FilterPeriodFromDisplayValue = ko.pureComputed(() => { return this.FilterPeriodFrom() ? moment(this.FilterPeriodFrom(), Bao.Utils.DateTimeFormat).format(Bao.Utils.DateDisplayFormat) : ""; });
    FilterPeriodToDisplayValue = ko.pureComputed(() => { return this.FilterPeriodTo() ? moment(this.FilterPeriodTo(), Bao.Utils.DateTimeFormat).format(Bao.Utils.DateDisplayFormat) : ""; });
    FilterIntervalDefaultStartDate = ko.observable("");
    FilterIntervalDefaultEndDate = ko.observable("");
    IsRead = ko.observable<boolean>(false);
    ReadByText = ko.observable<string>("");
    IsCanMarkAsRead = ko.observable<boolean>(false);
    Infos: KnockoutObservableArray<any> = ko.observableArray();
    RecordChangedMessage: KnockoutObservable<string>;
    TotalRows = ko.observable(0);
    TabPage: TabPage;
    PageIndex = ko.observable(0);
    PageSize = ko.observable(20);
    Sorting = ko.observableArray();
    CustomFilter = ko.observable(null);
    TabPageIsActive: KnockoutObservable<boolean>;
    ReportHasChanges: KnockoutObservable<boolean>;
    Columns: KnockoutObservableArray<{}> = ko.observableArray();
    TagColumns: KnockoutObservableArray<{}> = ko.observableArray();
    DialogWidth: number = 300;
    DateToJumpTo: KnockoutObservable<string> = ko.observable("");
    InputDateTimePicker = ko.observable();
    InfoSavedHandler: IMessageBusEventHandler = {
        name: 'notifyInfoSaved',
        handler: (result: { ids: Array<string> }) => this.checkAndNotifyIfRecordChanged(result.ids)
    };
    InfoDeletedHandler: IMessageBusEventHandler = {
        name: 'notifyInfoDeleted',
        handler: (result: { ids: Array<string> }) => this.checkAndNotifyIfRecordChanged(result.ids)
    };
    SettingsUrl: KnockoutObservable<string> = ko.observable(null);
    SettingsKeyPermission: KnockoutObservable<string> = ko.observable(null);
    SettingsKeyPermissionApplicationId: KnockoutObservable<string> = ko.observable(null);
    HideTransferred: KnockoutObservable<boolean> = ko.observable(false);

    constructor(tabPage: TabPage) {
        super(tabPage);

        this.SettingsKeyPermission("SummaryReportFilterEdit");
        this.SettingsKeyPermissionApplicationId(window.FinitoApplicationId);
        this.TabPage = tabPage;
        this.ReportHasChanges = ko.observable(false);
        this.TabPageIsActive = this.TabPage.IsActiveTab;
    }
    init() {
        this.TabPage.IsLoading(true);
        this.registerMenuClick();
        return $.when(this.LoadSummaryReports());
    }
    LoadSummaryReports(): any {
        return Bao.post("SummaryReportV2/GetSummaryReports").
            then((serverResult) => {
                ko.map.fromJS(serverResult.SummaryReports, this.availableSummaryFilters);
                this.TabPage.Title(serverResult.TabTitle);
                this.HideTransferred(JSON.parse(serverResult.HideTransferred));
            });
    }
    loaded() {
        this.dispose();
        let disableIsLoading = true;
        this.Sorting([{ Column: "InfoNr", Direction: "Descending" }]);
        var summaryReportId = baoRouter.getRouteValue("SummaryReportId", this.TabPage);
        if (summaryReportId != null) {
            var defaultReport = this.availableSummaryFilters().
                filter(e => e.SummaryReportId().toLowerCase() === summaryReportId.toLowerCase());
            if (defaultReport != null && defaultReport.length > 0) {
                this.SelectedSummaryFilter(defaultReport[0]);
                this.SelectedSummaryReportId(summaryReportId);
            }
        }
        this.SelectedSummaryFilter.subscribe(this.on_SelectedSummaryFilter_changed.bind(this));
        this.subscribe(this.TabPage.UrlData, (value) => {
            if (value.SummaryReportId && value.SummaryReportId != this.SelectedSummaryReportId() && this.availableSummaryFilters().some(b => ko.unwrap(b.SummaryReportId) == value.SummaryReportId)) {
                var defaultReport = this.availableSummaryFilters().
                    filter(e => e.SummaryReportId() === value.SummaryReportId);
                if (defaultReport != null && defaultReport.length > 0) {
                    this.SelectedSummaryFilter(defaultReport[0]);
                    this.SelectedSummaryReportId(value.SummaryReportId);
                }
            }
        });

        if (this.SelectedSummaryFilter()) {
            this.on_SelectedSummaryFilter_changed(this.SelectedSummaryFilter());
            disableIsLoading = false;
        }
        this.Sorting.subscribe(() => { this.Refresh(); });
        this.CustomFilter.subscribe(() => { this.ResetViewAndRefresh(); });
        this.PageIndex.subscribe(() => { this.Refresh(); });
        this.PageSize.subscribe(() => { this.ResetViewAndRefresh(); });
        this.FilterPeriodFrom.subscribe(() => {
            if (this.IsIndividually() && this.IsFilterSet()) {
                this.ResetViewAndRefresh();
            }
        });
        this.FilterPeriodTo.subscribe(() => {
            if (this.IsIndividually() && this.IsFilterSet()) {
                this.ResetViewAndRefresh();
            }
        });
        this.registerReportContentChangedHandler();
        this.RecordChangedMessage = Bao.Session.GetMessage('msgSummaryReportContentChanged');

        this.ReportHasChanges.subscribe(function (hasChanges) {
            if (hasChanges && this.TabPageIsActive()) {
                baoShouter.show(this.RecordChangedMessage(), 'warning', -1);
                this.ReportHasChanges(false);
            }
        }.bind(this));

        this.TabPageIsActive.subscribe(function (isActive) {
            if (isActive && this.ReportHasChanges()) {
                baoShouter.show(this.RecordChangedMessage(), 'warning', -1);
                this.ReportHasChanges(false);
            }
        }.bind(this));

        this.HideTransferred.subscribe((hideTransferred) => {
            Bao.post("SummaryReportV2/SetHideTransferred", JSON.stringify({
                hideTransferred
            })).then(() => { this.Refresh(); });
        });

        Bao.bindEvent('FavoriteIcon:refresh', (value) => {
            this.IsFavorite(!this.IsFavorite());
        });
        if (disableIsLoading) {
            this.TabPage.IsLoading(false);
        }
    }
    on_SelectedSummaryFilter_changed(newVal) {
        this.IsFilterSet(false);
        this.FilterIntervalDefaultEndDate(newVal.FilterIntervalDefaultEndDateHtml())
        this.FilterPeriodFrom(newVal.FilterIntervalDefaultStartDateHtml());
        this.FilterPeriodTo(this.CalculateEndDate());
        // Save Default period from for switch today
        this.FilterIntervalDefaultStartDate(newVal.FilterIntervalDefaultStartDateHtml());
        this.ResetViewAndRefresh(true);
        this.isQuickStartModuleActive();
        this.IsFilterSet(true);
        this.SettingsUrl(newVal.SummaryReportId() ? 'SummaryReportFilter/' + newVal.SummaryReportId() : null);
    }
    registerMenuClick() {
        BaoMenu.registerEvent((btn) => {
            if (!(this.TabPage != null && this.TabPage.IsActiveTab != null && this.TabPage.IsActiveTab() === true))
                return;
            let actionKey = btn.ActionKey();
            switch (actionKey) {
                case "SummaryReportPrevious":
                    this.PeriodGoToPrevious();
                    break;
                case "SummaryReportNext":
                    this.PeriodGoToNext();
                    break;
                case "SummaryReportRefresh":
                    this.Refresh();
                    break;
                case "SummaryReportPrint":
                    this.Print();
                    break;
                case "SummaryReportToday":
                    this.PeriodGoToday();
                    break;
                case "SummaryReportCalendar":
                    this.Calendar();
                    break;
                case "SummaryReportMarkRead":
                    this.MarkRead();
                    break;
                case "SummaryReportDownloadExcel":
                    this.DownloadExcel();
                    break;
            }
        });
    }
    Print() {
        this.TabPage.IsLoading(true);
        let cstFilter = ko.unwrap(this.CustomFilter);
        if (cstFilter === null || typeof cstFilter === "undefined") {
            cstFilter = {};
        }
        cstFilter.SummaryReportFilterId = this.SelectedSummaryFilter().SummaryReportId();
        cstFilter.ValidDate = this.FilterPeriodFrom();
        cstFilter.FilterPeriodTo = this.FilterPeriodTo();
        Bao.post("SummaryReportV2/GetDownloadSummaryReport", JSON.stringify({
            sorting: this.Sorting(),
            customFilter: this.toHashObject(ko.unwrap(this.CustomFilter))
        })).then((result) => {
            if (result.Result == true) {
                baoRouter.setHash("document/" + result.Message);
            }
            else {
                new BaoDialog(Bao.Session.GetApplicationName(), result.Message, "info");
            }
        }).always(() => {
            this.TabPage.IsLoading(false);
        });
    }
    Refresh(refreshColumnList: boolean = false) {
        this.TabPage.IsLoading(true);
        $.when(refreshColumnList ? this.SetColumns() : null, this.getSummaryReportData()).always(() => {
            this.ToggleButtons();
            this.TabPage.IsLoading(false);
        });
    }
    SetColumns() {
        return Bao.post("SummaryReportV2/GetAllColumns", JSON.stringify({
            summaryReportId: this.SelectedSummaryFilter().SummaryReportId()
        })).then(result => {
            this.Columns(result.Columns);
            this.TagColumns(result.TagColumns);
        });
    }
    ResetViewAndRefresh(refreshColumnList: boolean = false) {
        if (this.PageIndex() === 0) {
            this.TabPage.IsLoading(true);
            this.Refresh(refreshColumnList);
            return;
        }
        this.PageIndex(0);
        this.ToggleButtons();
    }
    private toHashObject(customFilter: any) {
        var returnValue = [];
        for (var f in customFilter) {
            returnValue.push({ Key: f, Value: ko.unwrap(customFilter[f]) });
        }
        return returnValue;
    }
    private getSummaryReportData() {
        let customFilter = this.toHashObject(this.CustomFilter());
        if (this.HideTransferred()) {
            customFilter.push({ Key: "HideTransferred", Value: ko.unwrap(this.HideTransferred) });
        }
        return Bao.post("SummaryReport/GetAll", JSON.stringify({
            summaryReportFilterId: this.SelectedSummaryFilter().SummaryReportId(),
            pageIndex: this.PageIndex(),
            pageSize: this.PageSize(),
            sorting: this.Sorting(),
            customFilter: customFilter,
            startTime: this.FilterPeriodFrom(),
            endTime: this.FilterPeriodTo()
        })).then(result => {
            this.Infos(result.Infos);
            this.TotalRows(result.TotalRows);
            this.ReadByText(result.ReadByText);
            this.IsRead(result.IsRead);
            this.IsCanMarkAsRead(result.IsCanMarkAsRead);
        });
    }

    private checkInfoRelevance(InfoIds: string[]) {
        var customFilterWithInfoId = this.toHashObject(this.CustomFilter());
        customFilterWithInfoId.push({ Key: "InfoIds", Value: JSON.stringify(InfoIds) });
        return Bao.post("SummaryReport/CheckInfoRelevance", JSON.stringify({
            summaryReportFilterId: this.SelectedSummaryFilter().SummaryReportId(),
            pageIndex: this.PageIndex(),
            pageSize: this.PageSize(),
            sorting: this.Sorting(),
            customFilter: customFilterWithInfoId,
            startTime: this.FilterPeriodFrom(),
            endTime: this.FilterPeriodTo()
        })).then(result => {
            return result.Result === true;
        });
    }

    PeriodGoToPrevious() {
        this.switchInterval(true);
        this.ResetViewAndRefresh();
    }
    PeriodGoToNext() {
        this.switchInterval();
        this.ResetViewAndRefresh();
    }
    PeriodGoToday() {
        this.FilterPeriodFrom(this.FilterIntervalDefaultStartDate());
        this.FilterPeriodTo(this.CalculateEndDate());
        this.ResetViewAndRefresh();
    }
    PeriodGoToNewDate() {
        return Bao.post("SummaryReportV2/CalculateFilterIntervalStartDate", JSON.stringify({
            value: this.DateToJumpTo(),
            filterIntervalKey: this.SelectedSummaryFilter().FilterIntervalKey(),
            filterInterval: this.SelectedSummaryFilter().FilterInterval(),
            individualInterval:this.SelectedSummaryFilter().FilterIntervalStartDay(),
            individualTime: this.SelectedSummaryFilter().FilterIntervalStartTime()
        })).then(result => {
            this.FilterPeriodFrom(result.Result);
            this.FilterPeriodTo(this.CalculateEndDate());
            this.ResetViewAndRefresh();
        });
    }
    private switchInterval = (switchBack?: boolean) => {
        if (this.FilterPeriodFrom()) {
            let filterInterval = this.SelectedSummaryFilter().FilterInterval();
            if (!filterInterval) {
                filterInterval = 1;
            }
            if (switchBack) {
                filterInterval = -filterInterval;
            }
            switch (this.SelectedSummaryFilter().FilterIntervalKey()) {
                case "Week":
                    this.FilterPeriodFrom(moment(this.FilterPeriodFrom(), Bao.Utils.DateTimeFormat).add(filterInterval, "w").format(Bao.Utils.DateTimeFormat));
                    break;
                case "Month":
                    this.FilterPeriodFrom(moment(this.FilterPeriodFrom(), Bao.Utils.DateTimeFormat).add(filterInterval, "M").format(Bao.Utils.DateTimeFormat));
                    break;
                case "Year":
                    this.FilterPeriodFrom(moment(this.FilterPeriodFrom(), Bao.Utils.DateTimeFormat).add(filterInterval, "y").format(Bao.Utils.DateTimeFormat));
                    break;
                case "Individually":
                    this.FilterPeriodFrom(moment(this.FilterPeriodFrom(), Bao.Utils.DateTimeFormat).add(filterInterval, "d").format(Bao.Utils.DateTimeFormat));
                    break;
                default:
                    this.FilterPeriodFrom(moment(this.FilterPeriodFrom(), Bao.Utils.DateTimeFormat).add(filterInterval, "d").format(Bao.Utils.DateTimeFormat));
                    break;
            }
            this.FilterPeriodTo(this.CalculateEndDate());
        }
    };
    private CalculateEndDate(): string {
        let filterInterval = this.SelectedSummaryFilter().FilterInterval();
        if (!filterInterval) {
            filterInterval = 1;
        }
        switch (this.SelectedSummaryFilter().FilterIntervalKey()) {
            case "Week":
                return (moment(this.FilterPeriodFrom(), Bao.Utils.DateTimeFormat).add(filterInterval, "w").add(-1, 'm').format(Bao.Utils.DateTimeFormat));
            case "Month":
                return (moment(this.FilterPeriodFrom(), Bao.Utils.DateTimeFormat).add(filterInterval, "M").add(-1, 'm').format(Bao.Utils.DateTimeFormat));
            case "Year":
                return (moment(this.FilterPeriodFrom(), Bao.Utils.DateTimeFormat).add(filterInterval, "y").add(-1, 'm').format(Bao.Utils.DateTimeFormat));
            case "Individually":
                if(this.FilterIntervalDefaultEndDate() !== undefined && this.FilterIntervalDefaultEndDate() !== null){
                    return (moment(this.FilterIntervalDefaultEndDate(), Bao.Utils.DateTimeFormat).format(Bao.Utils.DateTimeFormat));
                }
                return (moment(this.FilterPeriodFrom(), Bao.Utils.DateTimeFormat).add(1, "d").add(-1, 'm').format(Bao.Utils.DateTimeFormat));
            default:
                return (moment(this.FilterPeriodFrom(), Bao.Utils.DateTimeFormat).add(filterInterval, "d").add(-1, 'm').format(Bao.Utils.DateTimeFormat));
        }
    }
    changeFavoriteStatus = () => {
        var promise;
        if (this.IsFavorite()) {
            promise = this.removeQuickStartModuleWebUrl();
        }
        else {
            promise = this.addQuickStartModule();
        }
        promise.then(() => { Bao.raiseEvent('QuickStartModules:refresh', null); });
    };
    addQuickStartModule = () => {
        this.TabPage.IsLoading(true);
        return Bao.post("StartModule/AddQuickStartModule", JSON.stringify({
            caption1: this.SelectedSummaryFilter().Name(),
            caption2: this.SelectedSummaryFilter().Name(),
            caption3: this.SelectedSummaryFilter().Name(),
            caption4: this.SelectedSummaryFilter().Name(),
            caption5: this.SelectedSummaryFilter().Name(),
            webUrl: this.GetSummaryFilterDeepLink(),
            color: this.Color,
            icon: this.Icon,
            sort: this.Sort
        })).done(result => {
            if (result) {
                this.IsFavorite(true);
            }
            this.TabPage.IsLoading(false);
        });
    };
    removeQuickStartModuleWebUrl = () => {
        this.TabPage.IsLoading(true);
        return Bao.post("StartModule/RemoveQuickStartModuleByWebUrl", JSON.stringify({
            webUrl: this.GetSummaryFilterDeepLink()
        })).done(result => {
            if (result) {
                this.IsFavorite(false);
            }
            this.TabPage.IsLoading(false);
        });
    };
    isQuickStartModuleActive = () => {
        return Bao.post("StartModule/IsQuickStartModuleActive", JSON.stringify({
            webUrl: this.GetSummaryFilterDeepLink()
        })).done(result => {
            this.IsFavorite(result);
        });
    };
    GetSummaryFilterDeepLink() {
        return "#/SummaryReportV2/" + this.SelectedSummaryFilter().SummaryReportId();
    }
    MarkRead() {
        var dialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgMarkReportRead"), 'yesno');
        dialog.DialogResult.subscribe((result) => {
            if (result === true) {
                this.TabPage.IsLoading(true);
                Bao.post('SummaryReportV2/MarkRead', JSON.stringify({
                    summaryReportId: this.SelectedSummaryFilter().SummaryReportId(),
                    validDate: this.FilterPeriodFrom(),
                })).then((readResult) => {
                    this.Refresh();
                });
            }
            ;
        });
    }
    ToggleButtons() {
        BaoMenu.permissionVisible({ ActionKey: 'SummaryReportMarkRead', Visible: this.IsCanMarkAsRead() });
        BaoMenu.permissionEnable({ ActionKey: 'SummaryReportMarkRead', Enabled: !this.IsRead(), Context: this.TabPage.Context() });
        BaoMenu.permissionVisible({ ActionKey: 'SummaryReportPrevious', Visible: !this.SelectedSummaryFilter().IsIndividually() });
        BaoMenu.permissionVisible({ ActionKey: 'SummaryReportNext', Visible: !this.SelectedSummaryFilter().IsIndividually() });
        BaoMenu.permissionVisible({ ActionKey: 'SummaryReportToday', Visible: !this.SelectedSummaryFilter().IsIndividually() });
        BaoMenu.permissionVisible({ ActionKey: 'SummaryReportCalendar', Visible: !this.SelectedSummaryFilter().IsIndividually() });
    }
    getTagValue = function (tagId, info) {
        if (info.UniversalFieldValues !== undefined) {
            for (var n = 0; n < info.UniversalFieldValues.length; n++) {
                if (info.UniversalFieldValues[n].InfoId === info.InfoId && info.UniversalFieldValues[n].TagId === tagId) {
                    return info.UniversalFieldValues[n].TagValueHtml;
                }
            }
        }
        return "";
    };
    getTagType = function (tagId, info) {
        if (info.UniversalFieldValues !== undefined) {
            for (var n = 0; n < info.UniversalFieldValues.length; n++) {
                if (info.UniversalFieldValues[n].InfoId === info.InfoId && info.UniversalFieldValues[n].TagId === tagId) {
                    return info.UniversalFieldValues[n].UniversalFieldTypeId;
                }
            }
        }
        return "";
    };
    Calendar() {
        this.TabPage.IsLoading(true);
        return Bao.post("SummaryReportV2/CalendarDialog", (result) => {
            let dialog = new BaoDialog(Bao.Session.ApplicationName);
            dialog.ViewModel(this);
            dialog.Template(result);
            let okButton = new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("msgOk"), () => {
                this.PeriodGoToNewDate();
                dialog.Close();
            });
            let cancelButton = new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("msgCancel"), () => {
                dialog.Close();
            });
            if (this.DialogWidth != null) {
                dialog.Width(this.DialogWidth + "px");
            }
            dialog.Buttons([okButton, cancelButton]);
            dialog.Open();
            $(this.InputDateTimePicker()).datetimepicker({
                inline: true,
                format: "yyyyMMdd",
                locale: ko.unwrap(Bao.Session.Language.Symbol),
                icons: {
                    previous: 'fal fa-chevron-left',
                    next: 'fal fa-chevron-right'
                }
            });
            // set DateToJumpTo to today (first thing it is set to in datetimepicker)
            this.DateToJumpTo(moment($(this.InputDateTimePicker()).data['DateTimePicker']).format(Bao.Utils.DateTimeFormat));
            $(this.InputDateTimePicker()).on('dp.change', (e) => {
                this.DateToJumpTo(moment(e["date"]).format(Bao.Utils.DateTimeFormat));
            });
            this.TabPage.IsLoading(false);
        });
    }
    /**
     * Will export the data to the excel file
     * */
    DownloadExcel() {
        this.TabPage.IsLoading(true);

        Bao.post("SummaryReportV2/GetDownloadExcelSummaryReport", JSON.stringify({
            summaryReportId: this.SelectedSummaryFilter().SummaryReportId(),
            totalRows: this.TotalRows(),
            startTime: this.FilterPeriodFrom(),
            endTime: this.FilterPeriodTo()
        })).then((result) => {
            baoRouter.setHash("document/" + result);
        }).always(() => {
            this.TabPage.IsLoading(false);
        });
    }

    dispose() {
        super.dispose();
        MessageBus.unsubscribe([this.InfoSavedHandler,
        this.InfoDeletedHandler]);
    };

    private registerReportContentChangedHandler = () => {

        MessageBus.subscribe([this.InfoSavedHandler,
        this.InfoDeletedHandler])
            .catch(() => {
                console.warn('Cannot connect to MessageBus');
            });
    }

    private checkAndNotifyIfRecordChanged = (ids: Array<string>) => {
        //The ids array should almost always contain only one element

        //Do not notify multiple times
        if (this.ReportHasChanges())
            return;

        //Check if the record(s) exist in loaded infos (client side)
        for (var id of ids) {
            for (var inf of this.Infos()) {
                if (String(inf.InfoId).toLowerCase() === id.toLowerCase()) {
                    this.ReportHasChanges(true);
                    return;
                }
            }
        }
        //The record(s) aren't in loaded infos - check if they're relevant to the current report
        this.checkInfoRelevance(ids).then(result => {
            if (result) {
                this.ReportHasChanges(true);
            }
        });
    }
}
export default SummaryReportV2;